import React from "react";

import { Provider } from "react-redux";
import { CssBaseline, MuiThemeProvider } from "@material-ui/core";
import { BrowserRouter as Router } from "react-router-dom";

import Toaster from "./components/Toaster";
import SessionWrapper from "./components/SessionWrapper";
import CustomBackdrop from "./components/CustomBackdrop";

import theme from "./config/theme";
import store from "./redux/store";

import RoutesBuilder from "./components/RoutesBuilder";
import routes from "./config/routes";

import "./styles/index.css";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

function App() {
  localStorage.setItem("token", process.env.REACT_APP_Token);

  return (
    <MuiThemeProvider theme={theme}>
      <CssBaseline />
      <Provider store={store}>
        <SessionWrapper>
          <Router>
            <RoutesBuilder routes={routes} />
          </Router>
          <Toaster />
          <CustomBackdrop />
        </SessionWrapper>
      </Provider>
    </MuiThemeProvider>
  );
}

export default App;
